<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import FaqComponent from "@js/components/Faq/FaqComponent.vue";

export default defineComponent({
    name: "DemontazhAngarovPage",
    components: {
        FaqComponent,
        Breadcrumbs,
        MobileTopBar,
    },
    props: {
        faq: {
            type: Array,
            default: () => [],
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <MobileTopBar/>

    <div class="container mb-5 md:mb-10">
        <Breadcrumbs/>
        <section class="mb-5 md:mb-8">
            <div class="bg-grayBg rounded-3xl overflow-hidden">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center p-5 md:p-10">
                    <div class="max-w-4xl order-2 md:order-1">
                        <h1 class="text-2xl md:text-4xl font-bold mb-4 leading-tight">
                            Демонтаж ангаров
                        </h1>

                        <p class="text-sm md:text-base text-gray-700 leading-7 mb-6 md:mb-8">
                            Вторчермет-1 выполняет демонтаж ангаров в Москве и Московской области.
                            Разбираем металлические ангары, каркасные сооружения, складские и
                            производственные помещения с последующей резкой металла, погрузкой
                            и вывозом металлолома.
                        </p>

                        <div class="flex flex-col sm:flex-row gap-3">
                            <button
                                type="button"
                                @click="callbackStore.showBaseCallbackPopup?.({
                                title: 'Заявка на демонтаж ангара',
                                bitrix_title: 'Заявка на демонтаж ангара с сайта Вторчермет-1',
                                })"
                                class="px-5 py-3 rounded-2xl bg-baseColor text-black font-semibold transition hover:opacity-90"
                            >
                                Оставить заявку
                            </button>

                            <a
                                href="#stages"
                                class="text-center px-5 py-3 rounded-2xl border border-gray-300 font-semibold transition hover:border-baseColor"
                            >
                                Как проходит демонтаж
                            </a>
                        </div>
                    </div>

                    <div class="flex justify-end h-full order-1 md:order-2">
                        <img
                            src="@img/services/demontazhangarov.webp"
                            alt="Демонтаж металлоконструкций"
                            class="w-full max-h-[280px] h-full object-cover object-center rounded-3xl"
                        >
                    </div>
                </div>
            </div>
        </section>

        <section class="mb-5 md:mb-8">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div class="bg-white border border-gray-100 rounded-3xl p-5">
                    <h2 class="text-lg font-semibold mb-3">
                        Какие ангары демонтируем
                    </h2>
                    <p class="text-sm text-gray-700 leading-6">
                        Разбираем складские ангары, производственные ангары, каркасные
                        сооружения, металлические павильоны, временные конструкции
                        и крупногабаритные объекты из металла.
                    </p>
                </div>

                <div class="bg-white border border-gray-100 rounded-3xl p-5">
                    <h2 class="text-lg font-semibold mb-3">
                        Что входит в услугу
                    </h2>
                    <p class="text-sm text-gray-700 leading-6">
                        Осмотр объекта, согласование работ, разбор конструкций, резка
                        металла, сортировка, погрузка и вывоз металлолома с территории.
                    </p>
                </div>

                <div class="bg-white border border-gray-100 rounded-3xl p-5">
                    <h2 class="text-lg font-semibold mb-3">
                        Где работаем
                    </h2>
                    <p class="text-sm text-gray-700 leading-6">
                        Работаем по Москве и Московской области. Выезжаем на промышленные,
                        складские, строительные и коммерческие объекты.
                    </p>
                </div>
            </div>
        </section>

        <section id="stages" class="mb-5 md:mb-8">
            <div class="bg-grayBg rounded-3xl p-5 md:p-8">
                <h2 class="text-xl md:text-2xl font-bold mb-5">
                    Как проходит демонтаж ангаров
                </h2>

                <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div class="bg-white rounded-3xl p-5 border border-gray-100">
                        <div class="text-baseColor font-bold mb-2">01</div>
                        <p class="font-medium mb-2">Заявка</p>
                        <p class="text-sm text-gray-700 leading-6">
                            Вы оставляете заявку с описанием ангара, размеров и состояния конструкции.
                        </p>
                    </div>

                    <div class="bg-white rounded-3xl p-5 border border-gray-100">
                        <div class="text-baseColor font-bold mb-2">02</div>
                        <p class="font-medium mb-2">Осмотр объекта</p>
                        <p class="text-sm text-gray-700 leading-6">
                            Оцениваем объём работ, сложность разборки, подъезд техники и сроки выполнения.
                        </p>
                    </div>

                    <div class="bg-white rounded-3xl p-5 border border-gray-100">
                        <div class="text-baseColor font-bold mb-2">03</div>
                        <p class="font-medium mb-2">Демонтаж</p>
                        <p class="text-sm text-gray-700 leading-6">
                            Выполняем поэтапный разбор ангара, резку металла и подготовку к вывозу.
                        </p>
                    </div>

                    <div class="bg-white rounded-3xl p-5 border border-gray-100">
                        <div class="text-baseColor font-bold mb-2">04</div>
                        <p class="font-medium mb-2">Вывоз металла</p>
                        <p class="text-sm text-gray-700 leading-6">
                            Организуем погрузку и вывоз металлолома после завершения демонтажных работ.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="mb-5 md:mb-8">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <div class="bg-white border border-gray-100 rounded-3xl p-5 md:p-8">
                    <h2 class="text-xl md:text-2xl font-bold mb-4">
                        Когда требуется демонтаж ангара
                    </h2>

                    <ul class="space-y-3 text-sm md:text-base text-gray-700 leading-7 list-disc pl-5">
                        <li>При сносе старого складского или производственного ангара</li>
                        <li>При освобождении участка под новое строительство</li>
                        <li>При реконструкции территории или смене назначения объекта</li>
                        <li>При аварийном состоянии металлического сооружения</li>
                        <li>При необходимости быстро разобрать и вывезти металлоконструкции</li>
                    </ul>
                </div>

                <div class="bg-grayBg rounded-3xl p-5 md:p-8">
                    <h2 class="text-xl md:text-2xl font-bold mb-4">
                        Почему выбирают Вторчермет-1
                    </h2>

                    <ul class="space-y-3 text-sm md:text-base text-gray-700 leading-7 list-disc pl-5">
                        <li>Работаем с крупными металлическими сооружениями</li>
                        <li>Выезжаем по Москве и области</li>
                        <li>Помогаем с резкой, погрузкой и вывозом металла</li>
                        <li>Подходим к демонтажу поэтапно и организованно</li>
                        <li>Быстро обрабатываем заявки и согласовываем выезд</li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="mb-5 md:mb-10">
            <div
                class="relative overflow-hidden rounded-3xl p-5 md:p-10 text-white bg-gradient-to-br from-black via-gray-900 to-black">
                <div class="absolute -top-20 -right-20 w-72 h-72 bg-baseColor opacity-20 blur-3xl"></div>

                <div class="relative max-w-3xl">
                    <h2 class="text-xl md:text-3xl font-bold mb-4">
                        Нужен демонтаж ангара?
                    </h2>

                    <p class="text-sm md:text-base text-gray-300 leading-7 mb-6">
                        Оставьте заявку, и мы свяжемся с вами для уточнения параметров объекта,
                        объёма работ и организации выезда.
                    </p>

                    <button
                        type="button"
                        @click="callbackStore.showBaseCallbackPopup?.({
                                title: 'Заявка на демонтаж ангара',
                                bitrix_title: 'Заявка на демонтаж ангара с сайта Вторчермет-1',
                                })"
                        class="px-6 py-3 rounded-2xl bg-baseColor text-black font-semibold hover:opacity-90 transition"
                    >
                        Заказать демонтаж
                    </button>
                </div>
            </div>
        </section>
        <section v-if="faq?.length" class="mb-5 md:mb-8">
            <FaqComponent
                :items="faq"
                title="Частые вопросы"
                subtitle="Ответы на популярные вопросы по демонтажу ангаров"
                :open-first="true"
                :schema-enabled="false"
                wrapper-class="w-full bg-grayBg rounded-3xl text-black overflow-hidden p-5 md:p-10"
            />
        </section>
    </div>
</template>
